import React from 'react';
import { Menu, MenuItem } from '@mui/material';

import './styles.scss';

const OlcActionMenu = ({
  actions = [],
  anchorEl,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  className = '',
  children,
  disableScrollLock = true,
  id,
  labelledBy,
  MenuListProps = {},
  onClose,
  open = Boolean(anchorEl),
  PaperProps = {},
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  ...menuProps
}) => {
  const visibleActions = actions.filter((action) => !action.hidden);

  return (
    <Menu
      {...menuProps}
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableScrollLock={disableScrollLock}
      MenuListProps={{
        ...MenuListProps,
        'aria-labelledby': labelledBy,
      }}
      PaperProps={{
        ...PaperProps,
        className: ['olcTableActionMenu', 'olcStandardActionMenu', PaperProps.className, className]
          .filter(Boolean)
          .join(' '),
      }}
    >
      {children ??
        visibleActions.map(
          ({ closeOnSelect = true, disabled, icon, iconAlt, label, onClick, value = label }) => (
            <MenuItem
              key={value}
              disabled={disabled}
              onClick={async (event) => {
                try {
                  await onClick?.(event);
                } finally {
                  if (closeOnSelect) onClose?.();
                }
              }}
            >
              {typeof icon === 'string' ? (
                <img src={icon} alt={iconAlt ?? ''} aria-hidden={iconAlt ? undefined : true} />
              ) : (
                icon
              )}
              {label}
            </MenuItem>
          )
        )}
    </Menu>
  );
};

export default OlcActionMenu;
